<script>
    import PreviewElement from "./PreviewElement";
    import PaymentManagerElement from "../../components/pagesbuilder/elements/PaymentManagerElement";
    import axios from "commonjs/axios";
    import { mapState } from "vuex";

    export default {
        name: "PreviewPaymentManagerElement",
        mixins: [PreviewElement, PaymentManagerElement],
        data(){
            return {
               paymentLoading: false,
               canBeBought: true,
            }
        },
        computed:{
            ...mapState([
                'sessionCoupon'
            ]),
            getProduct(){                
                return this.myData.product;
            },            
        },
        methods:{
            elementCreationCallback(){
                this.setProductEnivronmentalProperties();
                this.retrieveProductData().then(response =>{
                    if(response.data.success){
                        this.originalProductData = response.data.product;
                        this.productData = {...response.data.product};
                        this.checkoutData = response.data.checkout;
                        this.canBeBought = response.data.product.can_be_bought

                        //Set Billing Info Additional Data
                        this.billingInfoComponent.setAdditionalInfo(this.checkoutData.additional);
                    }else{
                        this.canBeBought = false;
                    }
                });
                
            },
            setProductEnivronmentalProperties(){
                if (this.isPageContext('payment')){                    
                    this.myData.product = {
                        id: this.pageContext.params.product_id,
                        type: this.pageContext.params.product_type || 'course',
                        coupon: this.pageContext.params.coupon || this.sessionCoupon,
                        planId: this.pageContext.params.plan_id
                    }

                    
                    return this.myData.product;
                }else{
                    if(!this.myData.product.coupon){
                        this.myData.product.coupon = this.pageContext.params.coupon || this.sessionCoupon;
                    }
                }
            },
            setPaymentLoading(val){
                this.paymentLoading = val;                
            },
            retrieveProductData(){
                //Todo move to store?                
                return axios.get(`${server}product/${this.getProduct.id}?type=${this.getProduct.type}`);
            },
            requestValidation(){
                const validationPromises = [];
                ['billingInfoComponent','paymentMethodComponent', 'authenticationComponent'].forEach(component => {
                    validationPromises.push(this[component].validate());
                })
                                
                Promise.all(validationPromises).then(()=>{
                       this.paymentMethodComponent.initCheckout();   
                } ).catch( error => {
                    console.log('we have validation errors');
                });
                
                
            },
            setCoupon(coupon){
                this.myData.product.coupon = coupon;
            },
            updateAuthenticationForm(value){
                this.additionalAuthenticatonFormData = {
                    ...this.additionalAuthenticatonFormData,
                    ...value
                }                
            }
        },
        watch: {                
            paymentLoading: {
                handler(val, oldval){
                    if(val){
                        this.myNode.classList.add('disable-inputs');
                    }else{
                        this.myNode.classList.remove('disable-inputs');
                    }

                }
            },
            canBeBought: {
                handler(val){
                    this.paymentMessagesComponent.setVisibility(!val);
                    this.paymentMethodComponent.setVisibility(val);
                    this.billingInfoComponent.setVisibility(val);
                    this.authenticationComponent.setVisibility(val);                    
                }
            }
        }
    }
</script>
